<template>
    <section
        class="md-search-more-center clearfix template4"
        :class="[cls || '']"
        @touchend="onTouchend"
    >
        <div class="search-by-section">
            <div
                class="keyword-container"
                v-show="showLocation"
                @click="expand"
            >
                <div
                    class="search-category show-all"
                    :class="{ 'keyword-only': keywordOnly }"
                >
                    <SearchTag
                        @update="updateTag"
                        :collapse="collapse"
                        :filter="['mapPath', 'mapSearch', 'key', 'mapRadius']"
                        v-if="!keywordOnly"
                    />
                    <div
                        v-if="isMobileSize || !hasTag || !collapse"
                        :class="{ keyword: true, 'first-line': !hasTag }"
                    >
                        <div
                            class="keyword-submit"
                            role="button"
                            tabindex="0"
                            :aria-label="'Search'"
                            @click="handleEnter()"
                        >
                            <i class="iconfont icon-search-bold" aria-hidden="true"></i>
                        </div>
                        <input
                            type="search"
                            class="search-input"
                            ref="input"
                            @input="handleInput"
                            @click.stop="inputClick"
                            @keypress.enter="handleEnterAndTrack()"
                            v-model="keyword"
                            :placeholder="keywordPlaceholders"
                            autocomplete="off"
                            :aria-label="keywordPlaceholders || 'Search keyword'"
                        />
                        <template v-if="keywordOnly">
                            <div
                                class="btn-remove iconfont icon-close"
                                @click="keyword = ''"
                                v-show="keyword"
                            ></div>
                            <div class="btn-close" @click="close">
                                {{ $t('md-search-bar.close') }}
                            </div>
                        </template>
                        <div
                            class="list-panel panel-style"
                            v-if="
                                (doShowSuggestion &&
                                    keyWordSuggestion.length) ||
                                    keywordOnly
                            "
                        >
                            <ul class="reco-search" @click.stop>
                                <template v-if="recentlySearch.length > 0">
                                    <li key="recentlySearch" class="type-title">
                                        {{ $t('md-search-bar.recentlySearch') }}
                                    </li>
                                    <li
                                        v-for="(item, index) in recentlySearch"
                                        :key="
                                            item.keywordType +
                                                '-recent-' +
                                                index
                                        "
                                        :type="item.keywordType"
                                        @click="
                                            selectSuggestion(
                                                item.keywordType,
                                                item.keyword
                                            )
                                        "
                                    >
                                        {{ item.keyword }}
                                    </li>
                                </template>
                                <template
                                    v-for="(item, index) in keyWordSuggestion"
                                >
                                    <li
                                        v-if="!item.value"
                                        :key="'type-' + index"
                                        class="type-title"
                                    >
                                        {{ item.label }}
                                    </li>
                                    <li
                                        v-else
                                        :key="item.type + '-' + index"
                                        :type="item.type"
                                        @click="
                                            clickSuggestion(
                                                item.type,
                                                item.value
                                            )
                                        "
                                    >
                                        {{ item.label }}
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="keyword-submit"
                        role="button"
                        tabindex="0"
                        :aria-label="'Search'"
                        @click="handleEnter()"
                    >
                        <i class="iconfont icon-search-bold"></i>
                        <div>
                            <label>{{ $t('md-search-bar.search0') }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <SearchTag
                class="mobile"
                v-if="!keywordOnly && isMobileSize"
                :conditionSort="conditionSort"
                :exclude="true"
                :filter="ignoreTags"
            />
            <div
                v-if="!keywordOnly && !locationOnly"
                class="search-more search-detail mg-scrollbar"
                ref="searchMoreContainer"
            >
                <template v-if="!isMobileSize">
                    <div class="search-detail-wrap">
                        <template v-for="item in propertyConfigs">
                            <div
                                :key="item.name"
                                v-if="item.inputType == 'suggestion'"
                                class="search-detail-item"
                            >
                                <Suggestion
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :key="item.name"
                                    :inMore="false"
                                    :siteId="siteId"
                                    theme="template4"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            []
                                    "
                                    @change="updateCondition"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="
                                    item.inputType == 'singleSelect' ||
                                        item.inputType == 'multiSelect'
                                "
                                class="search-detail-item"
                            >
                                <SelectVirtual
                                    :multiple="item.inputType == 'multiSelect'"
                                    :inputType="item.inputType"
                                    :options="item.options"
                                    :label="item.label"
                                    :kee="item.name"
                                    :hasFilter="0"
                                    type="dropdown"
                                    theme="template4"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) || ['']
                                    "
                                    @change="updateCondition"
                                    @toogledropdown="toogledropdownOuter"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="
                                    item.inputType == 'inputBox' ||
                                        item.inputType == 'text' ||
                                        item.inputType == 'keyWord'
                                "
                                class="search-detail-item"
                            >
                                <OutsideRange
                                    cls="selectdown click-show-list"
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :inMore="false"
                                    theme="template4"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            ''
                                    "
                                    @change="updateCondition"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="item.inputType == 'checkBox'"
                                class="search-detail-item"
                            >
                                <OutsideCheckbox
                                    cls="selectdown click-show-list"
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :inMore="false"
                                    theme="template4"
                                    :checked="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            false
                                    "
                                    @change="updateSelected"
                                />
                            </div>
                        </template>
                        <!-- More start -->
                        <div
                            :class="
                                'search-detail-item more-btn' +
                                    (showMore ? ' open' : '')
                            "
                            v-show="showMoreBtn && !widget"
                            @click="clickMore"
                        >
                            <div class="box-div">
                                <span class="logo iconfont icon-list"></span>
                                <label class="text">{{
                                    $t('md-search-bar.more')
                                }}</label>
                                <label class="more-len">
                                    {{ moreLen ? '(' + moreLen + ')' : '' }}
                                </label>
                                <span class="iconfont icon-small-down"></span>
                            </div>
                        </div>
                        <!-- More end -->
                    </div>
                </template>
                <div
                    ref="more"
                    :class="
                        'mg-container more-list' +
                            (showMore ? ' show-more-list' : '')
                    "
                    v-outsideclick="clickMoreOut"
                    :style="{
                        height: !isMobileSize ? moreHeight + 'px' : 'auto'
                    }"
                >
                    <label class="checkbox-values"></label>
                    <div
                        v-if="isMobileSize || showMoreLoad"
                        class="more-list-scroll mg-scrollbar"
                    >
                        <div class="more-reset" @click="reset">
                            <span class="text">{{
                                $t('md-search-bar.reset')
                            }}</span><span class="iconfont icon-reset"></span>
                        </div>
                        <div
                            class="section-box search_tag"
                            v-if="!keywordOnly && !isMobileSize"
                        >
                            <SearchTag
                                :exclude="true"
                                :filter="tagFilter"
                                :hideRemoveAll="true"
                                :collapse="false"
                                :conditionSort="conditionSort"
                                :inMore="true"
                            />
                        </div>
                        <div
                            v-for="(item, sectionIndex) in searchList"
                            :key="item.id"
                            :class="
                                'section-box' +
                                    (item.column == 2 ? ' section-second' : '')
                            "
                        >
                            <h2
                                :class="{
                                    'show-list':
                                        activeSectionIndex === sectionIndex
                                }"
                                @click="toggleActiveSection(sectionIndex)"
                            >
                                <label class="text">{{
                                    item.nameText || item.name
                                }}</label>
                                <span class="iconfont icon-small-down"></span>
                            </h2>
                            <div class="section">
                                <template v-for="childItem in item.conditions">
                                    <Checkbox
                                        v-if="childItem.inputType == 'checkBox'"
                                        :key="childItem.name"
                                        :kee="childItem.name"
                                        :label="childItem.label"
                                        :inMore="true"
                                        :checked="
                                            (conditions[childItem.name] &&
                                                conditions[childItem.name]
                                                    .value) ||
                                                selectedParams[childItem.name] ||
                                                false
                                        "
                                        @change="updateSelected"
                                    />
                                    <div
                                        class="inputtext-area"
                                        v-if="childItem.inputType == 'inputBox'"
                                        :key="childItem.name"
                                    >
                                        <Range
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :inMore="true"
                                            theme="template4"
                                            :value="
                                                (conditions[childItem.name] &&
                                                    conditions[childItem.name]
                                                        .value) ||
                                                    selectedParams[
                                                        childItem.name
                                                    ] ||
                                                    ''
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType ==
                                                'singleSelect' ||
                                                childItem.inputType == 'multiSelect'
                                        "
                                        :key="childItem.name"
                                    >
                                        <SelectVirtual
                                            :multiple="
                                                childItem.inputType ==
                                                    'multiSelect'
                                            "
                                            :inputType="childItem.inputType"
                                            :options="childItem.options"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            theme="template4"
                                            type="input"
                                            :value="
                                                (conditions[childItem.name] &&
                                                    conditions[childItem.name]
                                                        .value) || ['']
                                            "
                                            @change="updateCondition"
                                            @hideSearch="$emit('hideSearch')"
                                            @showSearch="$emit('showSearch')"
                                            @toogledropdown="toogledropdown"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="childItem.inputType == 'text'"
                                        :key="childItem.name"
                                    >
                                        <SInput
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            theme="template4"
                                            :inMore="true"
                                            :value="
                                                (conditions[childItem.name] &&
                                                    conditions[childItem.name]
                                                        .value) ||
                                                    selectedParams[
                                                        childItem.name
                                                    ] ||
                                                    ''
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="childItem.inputType == 'keyWord'"
                                        :key="childItem.name"
                                    >
                                        <Keyword
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            theme="template4"
                                            :inMore="true"
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType === 'suggestion'
                                        "
                                        :key="childItem.name"
                                    >
                                        <!--  cls="range-input-parent" -->
                                        <Suggestion
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :inMore="true"
                                            :siteId="siteId"
                                            theme="template4"
                                            :value="
                                                (conditions[childItem.name] &&
                                                    conditions[childItem.name]
                                                        .value) ||
                                                    selectedParams[
                                                        childItem.name
                                                    ] ||
                                                    []
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <label
                :class="['save-search', 'hide-icon']"
                v-if="
                    !forCMS && !hideSearchBtn && !locationOnly && searchBarOnly
                "
                @click="saveSearch"
            >{{ $t('md-search-bar.search') }}</label>
            <label
                :class="['save-search', saveAble ? '' : ' disabled']"
                v-if="
                    !forCMS &&
                        !hideSearchBtn &&
                        !locationOnly &&
                        !searchBarOnly &&
                        listingType !== 'sold-listing' &&
                        !widget
                "
                @click="saveSearch"
            >
                <span class="iconfont icon-heart-fill"></span>{{ $t('md-search-bar.saveSearch') }}</label>
            <im-popper
                v-if="
                    !forCMS &&
                        !locationOnly &&
                        (hideSearchBtn || listingType == 'sold-listing') &&
                        !widget
                "
                :disabled="!!snapshotAbled"
                :visibleArrow="true"
                :hover="true"
                :popperHover="true"
                placement="top-end"
                :offset="[0, 8]"
            >
                <template #reference>
                    <label
                        :class="[
                            'save-search',
                            'save-snapshot',
                            snapshotAbled ? '' : ' disabled'
                        ]"
                        @click="clickSaveSnapshot"
                    >{{ $t('md-search-bar.saveSnapshot') }}</label>
                </template>
                <template #default>
                    <div class="tooltip dark">
                        {{ cmpSnapshotHoverTip }}
                    </div>
                </template>
            </im-popper>
        </div>
    </section>
</template>

<script>
import SearchTag from './search-tag-center.vue';
import OutsideRange from '../_component/outside-range';
import OutsideCheckbox from '../_component/outside-checkbox';
import Range from '../_component/range';
import SelectVirtual from '@/components/virtualize/select.vue';
import SInput from '../_component/s-input';
import Checkbox from '../../../components/checkbox.vue';
import Suggestion from '../_component/suggestion';
import Keyword from '../_component/keyword';
import Core from '../search-more-center';
export default {
    emits: ['hideSearch', 'showSearch'],
    mixins: [Core],
    data: function() {
        return {
            isTitleUppercase: true
        };
    },
    components: {
        SearchTag,
        SelectVirtual,
        Range,
        Checkbox,
        SInput,
        OutsideRange,
        OutsideCheckbox,
        Suggestion,
        Keyword
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../search-more.scss';
@mixin inputLableStyle() {
    margin-right: 20px;
    background-color: white;
    height: 40px;
    line-height: 36px;
    border: 2px solid #d6dae8;
    box-shadow: none;
    @include media-800 {
        margin-right: 0;
        line-height: 14px;
        padding-top: 11px;
        padding-bottom: 11px;
    }
}

$listHoverColor: #f6f7fb;
.md-search-more-center.template4 {
    .search-by {
        display: none;
    }
    .show-list,
    .show-more {
        .icon-small-down:after {
            transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
        }
        .list-panel {
            display: block;
        }
    }
    .panel-style {
        box-sizing: border-box;
        overflow-y: auto;
        width: 100%;
        max-height: 300px;
        position: absolute;
        left: 0;
        padding: 10px 0;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        border: 1px solid #ebecf1;
        background: #fff;
        min-width: 85px;
        z-index: var(--level-subhigh);
        color: #6b7282;
        li {
            line-height: 32px;
            padding: 0 0 0 10px;
            cursor: pointer;
            height: 32px;
            display: block;
            overflow: hidden;
            > span {
                width: calc(100% - 30px);
                @include ellipsis();
                display: inline-block;
            }
            .iconfont {
                display: none;
                float: right;
                padding-right: 14px;
                font-size: 12px;
            }
            &:hover {
                background-color: #f1f1f1;
            }
            &.selected {
                @include color-button-color();
                .iconfont {
                    display: block;
                }
            }
        }
    }
    .keyword {
        .list-panel {
            overflow-y: auto;
            .type-title {
                font-family: var(--font-medium);
                padding-left: 10px;
                text-transform: capitalize;
                &:hover {
                    background-color: white;
                    cursor: default;
                }
            }
        }
    }
}

.md-search-more-center.template4 {
    .more-keywords {
        width: 100%;
        display: flex;
        .inputtext-area {
            position: relative;
            padding-right: 20px;
            .keywords-input {
                @include inputLableStyle();
                margin-right: 0;
                width: 100%;
                padding: 0 98px 0 16px;
            }
            .keywords-button {
                position: absolute;
                bottom: 0;
                right: 20px;
                @include color-button();
                opacity: 0.9;
                width: 82px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 0 3px 3px 0;
                color: white;
                font-family: var(--font-bold);
                outline: none;
                font-size: 14px;
                &:hover {
                    opacity: 1;
                }
            }
            .tag-container {
                margin-top: -5px;
                .keywords-tag {
                    padding: 0 15px;
                    background: rgb(246, 246, 246);
                    font-size: 14px;
                    color: rgb(42, 42, 42);
                    margin-right: 10px;
                    display: inline-block;
                    box-sizing: border-box;
                    height: 40px;
                    line-height: 40px;
                    margin-top: 5px;
                    .icon-close {
                        color: #fff;
                        color: #d1d1d1;
                        margin-left: 8px;
                        vertical-align: middle;
                        &:hover {
                            cursor: pointer;
                            color: rgb(42, 42, 42);
                        }
                    }
                }
            }
        }
    }

    @include media-min-800 {
        font-size: 14px;
        .if-is-phone {
            display: none;
        }
        background-color: white;
        padding: 30px;
        input {
            &:focus {
                outline: none;
                border: 1px solid;
                @include color-theme('border-color');
            }
        }
        .click-show-list,
        .more-btn {
            position: relative;
        }
        .list-panel {
            width: auto;
            min-width: 100%;
            li {
                line-height: 32px;
                padding: 0 10px 0 20px;
                cursor: pointer;
                height: 32px;
                display: block;
                position: relative;
                &.filter-content {
                    .iconfont {
                        position: absolute;
                        display: block;
                        padding: 0;
                        width: 20px;
                        text-align: center;
                        left: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    .filter-input {
                        width: 100%;
                        padding-left: 20px;
                        height: 30px;
                        border: none;
                        box-shadow: none;
                    }
                    &:hover {
                        background-color: transparent;
                    }
                }
                > span {
                    width: auto;
                    padding-right: 30px;
                    display: inline-block;
                }
                .iconfont {
                    display: none;
                    float: none;
                    position: absolute;
                    right: 0;
                    top: 0;
                    padding-right: 14px;
                    font-size: 12px;
                }
                &:hover {
                    background-color: #f1f1f1;
                }
                &.selected {
                    @include color-button-color();
                    .iconfont {
                        display: block;
                    }
                }
            }
        }
        .more-list {
            position: absolute;
            max-width: none;
            z-index: calc(var(--level-sublow) + 1);
            top: 100%;
            right: 0;
            box-shadow: 0 2px 8px 0 rgba(28, 32, 38, 0.4);
            display: none;
            background-color: white;
            input {
                font-size: 14px;
            }
            &.show-more-list {
                display: block;
            }
            .checkbox-values {
                display: none;
            }
            .more-list-scroll {
                position: absolute;
                padding-top: 30px;
                top: 0;
                bottom: 0;
                overflow-y: auto;
                left: 0;
                right: 0;
                display: flex;
                flex-direction: column;
                .more-reset {
                    position: absolute;
                    right: 30px;
                    top: 30px;
                    @include color-theme('color');
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    .text {
                        margin-right: 3px;
                    }
                    .iconfont {
                        transform: rotate(90deg);
                    }
                }
            }
            .section-box {
                padding: 0 0px 40px 30px;
                flex: none;
                display: flex;
                flex-direction: column;
                &.search_tag {
                    padding-bottom: 28px;
                    .md-search-tag .search-filter > label {
                        color: #4a4a60;
                        line-height: 22px;
                    }
                    .md-search-tag .search-filter > label .icon-close {
                        height: 22px;
                        line-height: 22px;
                        border-radius: 0;
                    }
                }
                h2 {
                    font-size: 20px;
                    font-weight: normal;
                    font-family: var(--font-title);
                    height: 20px;
                    line-height: 20px;
                    color: #4a4a60;
                    .icon-small-down {
                        display: none;
                    }
                }
                .section {
                    width: 100%;
                    display: flex;
                    flex-flow: row wrap;
                    .inputtext-area {
                        width: 50%;
                        font-size: 14px;
                        margin-top: 20px;
                        box-sizing: border-box;
                        padding-right: 20px;
                        .name {
                            font-size: 17px;
                            font-family: var(--font-bold);
                            line-height: 26px;
                            color: #6b7282;
                            display: block;
                            padding-bottom: 4px;
                        }
                    }
                    .checkbox-li {
                        width: 20%;
                        line-height: 16px;
                        display: flex;
                        margin-top: 16px;
                        align-items: baseline;
                        /* cursor: pointer; */
                        color: #4a4a60;
                        .iconfont {
                            box-shadow: none;
                            border-radius: 0;
                            font-size: 12px;
                            line-height: 13px;
                            font-weight: bold;
                        }
                    }
                    .inputtext-area {
                        & + .checkbox-li {
                            width: 100%;
                            margin-top: 20px;
                            & + .checkbox-li {
                                margin-left: -80%;
                            }
                        }
                    }
                }
                .range-input-parent {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    position: relative;
                    .input-container {
                        flex: 1;
                        padding-right: 20px;
                        margin: 0;
                        input {
                            @include inputLableStyle();
                            margin-right: 0;
                            line-height: 20px;
                            width: 100%;
                            padding: 0 16px;
                        }
                    }
                    .price-line {
                        content: '';
                        position: absolute;
                        top: 19px;
                        left: 50%;
                        width: 6px;
                        height: 2px;
                        background-color: #dde0ec;
                        transform: translateX(-13px);
                    }
                }
                .selectdown {
                    @include inputLableStyle();
                    .title {
                        width: 100%;
                        display: flex;
                    }
                    .text {
                        flex: 1;
                        display: block;
                        @include ellipsis();
                        padding: 0 15px;
                        cursor: pointer;
                        font-size: 14px;
                        color: #4a4a60;
                    }
                    .filter-input {
                        flex: 1;
                        border: none;
                        box-shadow: none;
                        padding: 0 15px;
                        cursor: pointer;
                        font-size: 14px;
                        color: #4a4a60;
                    }
                    .list-panel {
                        top: 40px;
                    }
                }
            }
            .section-second {
                padding: 0 0 40px 0;
                h2 {
                    position: relative;
                    padding: 0 30px;
                    font-weight: normal;
                    .icon-small-down {
                        position: absolute;
                        top: 0;
                        right: 0;
                    }
                }
                .section {
                    padding: 0 10px 0 30px;
                }
            }
        }
        @include media-1080 {
            .more-list {
                width: 100vw;
                right: -30px;
                margin: 0;
            }
        }
        .search-by-section {
            position: relative;
            z-index: auto;
            top: 0;
            display: flex;
            @include placeholderMix(var(--font-normal), #8b93a7, 14px);
            .keyword-container {
                margin-right: 20px;
                flex-grow: 1;
                height: 50px;
                position: relative;
                .search-category {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    z-index: calc(var(--level-sublow));
                    background: #f5f6fa;
                    box-sizing: content-box;
                    .search-by {
                        position: relative;
                        background-color: white;
                        padding: 0 20px;
                        cursor: pointer;
                        color: #8b93a7;
                        // display: flex;
                        > .text {
                            cursor: pointer;
                            display: block;
                            @include ellipsis();
                        }
                        &.show-list {
                            min-width: 165px;
                            .icons:after {
                                transform: rotate(180deg);
                                -webkit-transform: rotate(180deg);
                            }
                            .panel-style {
                                top: 50px;
                            }
                        }
                    }
                    .keyword {
                        flex: 1;
                        position: relative;
                        width: 100%;
                        &.hide {
                            display: none;
                        }
                        .search-input {
                            width: 100%;
                            height: 50px;
                            line-height: 14px;
                            font-size: 14px;
                            color: #4a4a60;
                            padding-left: 12px;
                            border: none;
                            box-shadow: none;
                            -webkit-appearance: none;
                            background-color: #f5f6fa;
                            &:focus {
                                outline: none;
                            }
                        }
                        .keyword-submit {
                            display: none;
                        }
                        &.first-line {
                            .search-input {
                                padding-left: 42px;
                            }
                        }
                    }
                    .keyword-submit {
                        position: absolute;
                        top: 0;
                        left: 13px;
                        height: 50px;
                        width: 18px;
                        line-height: 50px;
                        text-align: center;
                        cursor: pointer;
                        .iconfont {
                            font-size: 18px;
                            font-weight: bold;
                            color: #6b7282;
                        }
                        div {
                            display: none;
                        }
                    }
                }
            }
            .save-search {
                padding-left: 18px;
                padding-right: 18px;
                margin-top: 9px;
                margin-left: 20px;
                cursor: pointer;
                @include color-button();
                position: relative;
                height: 32px;
                line-height: 32px;
                color: white;
                font-size: 14px;
                white-space: nowrap;
                border-radius: 2px;
                display: flex;
                align-items: center;
                font-family: var(--mg-button-font);
                .icon-heart-fill {
                    font-size: 12px;
                    margin-right: 4px;
                }
                &.disabled {
                    cursor: not-allowed;
                }
                &.save-snapshot {
                    padding: 0 10px;
                    text-align: center;
                    display: block;
                    height: 100%;
                }
            }
            @include media-1260 {
                flex-wrap: wrap;
                justify-content: space-between;
                .keyword-container {
                    width: 100%;
                    // margin-bottom: 20px;
                    margin-right: 0;
                }
                .search-more,
                .save-search {
                    margin-top: 20px;
                }
            }
        }
        .search-more {
            padding-top: 4px;
            .list-panel {
                top: 50px;
            }
            .search-detail-wrap {
                display: flex;
                margin: 0 auto;
                border-bottom: none;
                align-items: center;
                position: relative;
                .search-detail-item {
                    background-color: white;
                    color: #8b93a7;
                    position: relative;
                    height: 42px;
                    line-height: 42px;
                    align-items: center;
                    margin: 0 10px;
                    .name {
                        display: none;
                    }
                    .box-div {
                        width: 100%;
                        height: 100%;
                        align-items: center;
                        display: flex;
                        .title {
                            height: 100%;
                            flex: 1;
                            display: flex;
                            overflow: hidden;
                            cursor: pointer;
                            font-size: 16px;
                            font-family: var(--font-medium);
                            color: #8b93a7;
                        }
                        .logo {
                            font-size: 16px;
                            margin-right: 10px;
                            color: #8b93a7;
                            cursor: pointer;
                        }
                        .hide-logo-long {
                            display: none;
                        }
                        .split-line {
                            height: 30px;
                            width: 1px;
                            background-color: #ebecf1;
                        }
                        .icon-small-down {
                            margin-left: 6px;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        @media (min-width: 1260px) and (max-width: 1440px) {
                            padding-left: 10px;
                            .logo {
                                display: none;
                            }
                        }
                    }
                    &:last-child {
                        > div {
                            border: none;
                        }
                    }
                    &.select {
                        flex: auto;
                        width: auto;
                        display: flex;
                        .box-div {
                            .text {
                                flex: 1;
                                @include ellipsis();
                                cursor: pointer;
                                &.web {
                                    display: block;
                                }
                                &.mobile {
                                    display: none;
                                }
                            }
                            .choosed-value {
                                // padding-right: 4px;
                                display: block;
                                @include ellipsis();
                            }
                        }
                    }
                    &.small-item {
                        width: auto;
                    }
                    &.range-item {
                        .title {
                            cursor: pointer;
                            label {
                                cursor: pointer;
                            }
                        }
                    }
                }
                .show-list {
                    color: #4a4a60;
                    .box-div .title {
                        color: #4a4a60;
                    }
                    .range-input-parent.list-panel {
                        display: flex;
                        z-index: var(--level-subhigh);
                    }
                }
                .range-input-parent {
                    width: calc(100% - 50px);
                    &.box-div {
                        display: flex;
                        align-items: center;
                        cursor: auto;
                        .text {
                            margin-right: 6px;
                            cursor: default;
                            flex: inherit;
                        }
                    }
                    &.list-panel {
                        position: absolute;
                        width: 316px;
                        left: 0;
                        box-shadow: 0 2px 8px 0 rgba(28, 32, 38, 0.4);
                        border: none;
                        background-color: white;
                        padding: 20px;
                        justify-content: space-between;
                        .input-container {
                            width: 120px;
                            margin: 0;
                            line-height: normal;
                            .list-panel {
                                // display: block;
                                border: none;
                                box-shadow: none;
                                margin-top: 10px;
                                padding: 0;
                                position: relative;
                                top: 0;
                                left: 0;
                                &.disabled {
                                    cursor: not-allowed;
                                    display: none;
                                    color: #8b93a7;
                                    &:after {
                                        content: '';
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 100%;
                                        height: 100%;
                                        z-index: 1;
                                    }
                                }
                                li {
                                    padding: 0 10px;
                                    span {
                                        width: 100%;
                                        padding: 0;
                                    }
                                }
                            }
                        }
                        .price-line {
                            margin-top: 14px;
                        }
                    }
                    .price-line {
                        width: 6px;
                        height: 2px;
                        background-color: #dde0ec;
                        display: inline-block;
                        vertical-align: middle;
                        margin: 0 5px;
                    }
                    .input-container {
                        margin: 0 10px;
                        position: relative;
                        height: 100%;
                        .list-panel {
                            left: -0;
                            right: -50px;
                            width: inherit;
                        }
                        input {
                            width: 120px;
                            height: 30px;
                            padding: 0 10px;
                            box-shadow: none;
                            line-height: 16px;
                            color: #444f73;
                            border: 2px solid #d6dae8;
                        }
                        &.show-list {
                            input {
                                outline: none;
                                border: 1px solid;
                                @include color-theme('border-color');
                            }
                        }
                        &.input_1 {
                            margin-right: 0;
                        }
                    }
                }
                .select {
                    cursor: pointer;
                    max-width: auto;
                }
                .more-btn {
                    max-width: 200px;
                    position: static;
                    cursor: pointer;
                    font-size: 16px;
                    font-family: var(--font-medium);
                    color: #8b93a7;
                    .more-len {
                        text-align: right;
                        display: block;
                        padding-right: 0;
                        padding-left: 5px;
                    }
                    .logo.icons {
                        font-size: 14px;
                    }
                    .text {
                        cursor: pointer;
                    }
                    &.open {
                        color: #4a4a60;
                        .icon-small-down:before {
                            display: block;
                            transform: rotate(180deg);
                        }
                    }
                }
            }
            @include media-1080 {
                .icons.logo {
                    display: none;
                }
            }
        }
    }
    @include media-800 {
        color: #8b93a7;
        font-size: 14px;
        padding: 0;
        .mg-container {
            width: 100%;
            margin: 0;
            overflow: visible;
        }
        .icon-small-down {
            margin-right: 0;
            font-size: 22px;
            font-weight: bold;
            color: #d6dae8;
        }
        .search-by-section {
            .save-search,
            label.save-search {
                display: none;
            }
        }
        .search-category {
            margin-left: 0;
            margin-right: 0;
            background-color: #f5f6fa;
            padding: 20px 15px 20px;
            &.keyword-only {
                padding: 0;
                margin: 0;
                .keyword {
                    margin: 0;
                    padding: 0;
                    display: flex;
                    height: 40px;
                    align-items: center;
                    box-shadow: none;
                    border: none;
                    background-color: #f5f6fa;
                    input {
                        box-shadow: none;
                        height: 100%;
                        padding: 13px 10px 13px 43px;
                        background-color: #f5f6fa;
                    }
                    .keyword-submit {
                        position: absolute;
                        left: 15px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    .btn-remove {
                        position: absolute;
                        z-index: 2;
                        right: 84px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        border-radius: 50%;
                        background-color: #bfc9e4;
                        color: white;
                        &::before {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%) scale(0.7);
                            font-size: 12px;
                            font-weight: bold;
                        }
                    }
                    .btn-close {
                        width: 70px;
                        line-height: 26px;
                        font-size: 14px;
                        @include color-button-color();
                        text-transform: capitalize;
                        text-align: center;
                        border-left: 2px solid #bfc9e4;
                    }
                    .list-panel {
                        position: fixed;
                        top: 40px;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        box-shadow: none;
                        border: none;
                        max-height: none;
                        padding: 6px 0 0;
                        .type-title {
                            text-transform: uppercase;
                            background-color: #f5f6fa;
                        }
                        li {
                            padding: 0 20px;
                            &:hover {
                                background-color: #f5f6fa;
                            }
                        }
                    }
                }
            }
            .search-by {
                display: none;
            }
        }
        .keyword-submit {
            display: none;
        }
        .keyword {
            height: 40px;
            line-height: 40px;
            padding: 0;
            display: flex;
            align-items: center;
            position: relative;
            @include placeholderMix(var(--font-normal), #8b93a7);
            .search-input {
                border: none;
                box-shadow: none;
                height: 40px;
                line-height: 14px;
                flex: 1;
                border: none;
                padding: 13px 10px 13px 43px;
                box-shadow: none;
                @include ellipsis();
                &:focus {
                    border: none;
                }
            }
            .list-panel {
                top: 40px;
            }
            .keyword-submit {
                display: block;
                position: absolute;
                left: 15px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .search-more.search-detail {
            margin-top: 10px;
        }
        .search-detail-item {
            padding: 20px 15px 0;
            > .box-div,
            .selectdown {
                position: relative;
            }
            .logo {
                display: none;
            }
            &.small-item {
                padding-left: 0;
                padding-right: 0;
                display: inline-block;
                width: calc(50% - 28px);
                margin-right: 20px;
                margin-left: 15px;
                & + .small-item {
                    margin-left: 0;
                    margin-right: 0;
                }
            }
        }
        .price-line {
            width: 6px;
            height: 2px;
            vertical-align: middle;
            background-color: #dde0ec;
            display: inline-block;
            vertical-align: middle;
            margin: 0 8px;
        }
        .range-input-parent {
            position: static;
            display: flex;
            align-items: center;
            .input-container {
                position: relative;
                flex: 1;
            }
            .list-panel {
                display: none;
            }
        }
        .range-item {
            .input_0 {
                margin-right: 0;
            }
            .text,
            .title {
                display: none;
            }
        }
        .inputtext-area {
            flex: 1;
            margin-bottom: 20px;
            &.no-wrap {
                display: flex;
                align-items: center;
                .name {
                    margin-bottom: 0;
                    flex: none;
                    line-height: 14px;
                }
                .click-show-list {
                    flex: 1;
                    margin-left: 10px;
                    overflow: hidden;
                }
                .title {
                    border: none;
                    box-shadow: none;
                    height: auto;
                    padding: 7px 0;
                }
                .text {
                    text-align: right;
                    padding-right: 5px;
                }
                .list-panel {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    padding-top: 40px;
                    max-height: none !important;
                    border: none;
                    box-shadow: none;
                    .filter-content {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 40px;
                        padding: 0;
                        margin: 0;
                        background-color: #f5f6fa;
                        .icon-search {
                            display: block;
                            position: absolute;
                            left: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                            padding-right: 0;
                        }
                        .filter-input {
                            width: 100%;
                            height: 100%;
                            border: none;
                            box-shadow: none;
                            background-color: #f5f6fa;
                            padding: 0 75px 0 40px;
                        }
                        .close {
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 70px;
                            line-height: 26px;
                            font-size: 14px;
                            color: var(--mg-button-background, #03c9ff);
                            text-transform: capitalize;
                            text-align: center;
                            border-left: 2px solid #bfc9e4;
                        }
                    }
                    li:not(.filter-content) {
                        color: #4a4a60;
                        position: relative;
                        &:hover {
                            background-color: transparent;
                        }
                        .iconfont {
                            display: block !important;
                            right: 10px;
                            bottom: 8px;
                            position: absolute;
                            content: '';
                            -moz-osx-font-smoothing: grayscale;
                            width: 16px;
                            height: 16px;
                            border: solid 2px #d6dae8;
                            border-radius: 0;
                            box-shadow: none;
                            background-color: #ffffff;
                            text-align: center;
                            line-height: 13px;
                            padding: 0;
                            &::before {
                                display: none;
                                color: #fff;
                                font-size: 12px;
                                font-weight: bold;
                            }
                        }
                        &.selected .iconfont {
                            @include color-button();
                            &::before {
                                display: block;
                            }
                        }
                    }
                }
            }
            &:last-child {
                margin-bottom: 0;
            }
            .click-show-list {
                position: relative;
            }
        }
        .more-keywords {
            display: block;
            .inputtext-area {
                padding-right: 0;
                margin-bottom: 0;
                .keywords-button {
                    right: 0;
                }
                .tag-container {
                    margin-top: 0;
                }
            }
        }
        .section {
            margin-top: 20px;
        }
        .checkbox-li {
            padding: 0;
            height: 32px;
            line-height: 32px;
            flex-direction: row-reverse;
            display: flex;
            align-items: center;
            .label {
                flex: 1 0 0;
                padding-left: 0;
            }
            .iconfont {
                width: 16px;
                height: 16px;
                border: solid 2px #d6dae8;
                box-shadow: none;
                border-radius: 0;
                margin-right: 0;
                padding: 0;
                line-height: 13px;
                background-color: #ffffff;
                &::before {
                    font-size: 12px;
                    font-weight: bold;
                }
            }
            &.selected {
                .iconfont {
                    @include color-button();
                }
            }
            /* .label {
                    flex: 1;
                } */
            & + .inputtext-area {
                padding-top: 16px;
            }
        }
        .more-btn,
        .more-reset {
            display: none;
        }
        .section-box {
            padding: 30px 15px 0;
            h2 {
                display: flex;
                font-size: 16px;
                font-weight: normal;
                font-family: var(--font-title);
                line-height: 20px;
                .icon-small-down {
                    display: none;
                }
            }
            .search-detail-item {
                padding-left: 0;
                padding-right: 0;
            }
        }
        .section-second {
            padding: 0;
            border-bottom: solid 1px #e2e4ea;
            .section {
                display: none;
                margin-top: 0;
                padding: 0 15px 20px;
                .checkbox-li {
                    &:last-child {
                        padding-bottom: 0;
                    }
                }
            }
            h2 {
                padding: 20px 15px;
                .icon-small-down {
                    display: block;
                }
                &.show-list {
                    .icon-small-down {
                        transform: rotate(180deg);
                    }
                }
                &.show-list + .section {
                    display: block;
                }
            }
        }
        .text {
            flex: 1;
            @include ellipsis();
            padding-right: 15px;
            color: #4a4a60;
            &.web {
                display: none;
            }
            &.mobile {
                display: block;
            }
        }
        .choosed-value {
            display: none;
        }
        .title {
            display: flex;
            @include inputLableStyle();
            line-height: 40px;
            padding-left: 15px;
            padding-right: 15px;
        }
        input {
            @include inputLableStyle();
            line-height: 14px;
            padding-top: 11px;
            padding-bottom: 11px;
            padding-left: 15px;
            width: 100%;
            font-size: 14px;
        }
        .name {
            margin-bottom: 10px;
            font-family: var(--font-bold);
            color: #5a5f6e;
        }
        .checkbox-values {
            display: none;
        }
        .search-detail-item,
        .click-show-list {
            &.two-column {
                .box-div {
                    .name {
                        font-family: var(--font-bold);
                        color: #5a5f6e;
                    }
                    .title {
                        display: none;
                    }
                    .list-panel {
                        display: block !important;
                        position: inherit;
                        box-shadow: none;
                        border: none;
                        li {
                            width: calc(50% - 10px);
                            float: left;
                            height: 40px;
                            line-height: 37px;
                            color: #4a4a60;
                            text-align: center;
                            border: solid 2px #d6dae8;
                            padding: 0;
                            span {
                                width: 100%;
                            }
                            &:nth-child(odd) {
                                margin-right: 10px;
                            }
                            &:nth-child(even) {
                                margin-left: 10px;
                            }
                            &:hover {
                                background-color: transparent;
                            }
                            &.selected {
                                position: relative;
                                border: 2px solid var(--mg-button-background);
                                @include color-button-color;
                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 0;
                                    right: 0;
                                    top: 0;
                                    bottom: 0;
                                    background-color: var(
                                        --mg-button-background
                                    );
                                    opacity: 0.1;
                                }
                            }
                        }
                    }
                }
                &.two-column-4 {
                    .box-div .list-panel {
                        max-height: none;
                        li {
                            margin-bottom: 10px;
                            &:nth-child(n + 5) {
                                width: 100%;
                                padding: 0;
                                color: #4a4a60;
                                position: relative;
                                border: none;
                                margin-right: 0;
                                margin-left: 0;
                                margin-bottom: 0;
                                height: 32px;
                                line-height: 32px;
                                text-align: left;
                                &:hover {
                                    background-color: transparent;
                                }
                                &.selected {
                                    color: #4a4a60;
                                    &::before {
                                        display: none;
                                    }
                                }
                                .iconfont {
                                    display: block !important;
                                    right: 0;
                                    bottom: 8px;
                                    position: absolute;
                                    content: '';
                                    -moz-osx-font-smoothing: grayscale;
                                    width: 16px;
                                    height: 16px;
                                    border: solid 2px #d6dae8;
                                    border-radius: 0;
                                    box-shadow: none;
                                    background-color: #ffffff;
                                    text-align: center;
                                    line-height: 13px;
                                    padding: 0;
                                    &::before {
                                        display: none;
                                        color: #fff;
                                        font-size: 12px;
                                        font-weight: bold;
                                    }
                                }
                                &.selected .iconfont {
                                    @include color-button();
                                    &::before {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &.check-list {
                .box-div {
                    .name {
                        font-family: var(--font-bold);
                        color: #5a5f6e;
                    }
                    .title {
                        display: none;
                    }
                    .list-panel {
                        display: block !important;
                        position: inherit;
                        box-shadow: none;
                        border: none;
                        padding: 0;
                        li {
                            padding: 0;
                            color: #4a4a60;
                            position: relative;
                            &:hover {
                                background-color: transparent;
                            }
                            .iconfont {
                                display: block !important;
                                right: 0;
                                bottom: 8px;
                                position: absolute;
                                content: '';
                                -moz-osx-font-smoothing: grayscale;
                                width: 16px;
                                height: 16px;
                                border: solid 2px #d6dae8;
                                border-radius: 0;
                                box-shadow: none;
                                background-color: #ffffff;
                                text-align: center;
                                line-height: 13px;
                                padding: 0;
                                &::before {
                                    display: none;
                                    color: #fff;
                                    font-size: 12px;
                                    font-weight: bold;
                                }
                            }
                            &.selected .iconfont {
                                @include color-button();
                                &::before {
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
            &.select-list {
                .box-div {
                    .name {
                        font-family: var(--font-bold);
                        color: #5a5f6e;
                    }
                    .list-panel {
                        z-index: 999;
                    }
                }
            }
        }
    }
}
</style>
